import { GeneralService } from './../../services/general.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css']
})
export class MainLayoutComponent implements OnInit {

  constructor(private gs: GeneralService) {}

  ngOnInit() {
  }

  toggle() {
    this.gs.getSubmenEl.classList.add('d-none')
    document.getElementById('searchBoxForm').classList.add('d-none');    
  }

}
